export default __webpack_public_path__ + "./images/sr.f27744ea.png";